import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import InputLabel from '@mui/material/InputLabel';
import { Divider, IconButton } from '@mui/material';
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from 'react-i18next';
import ContainedButton from '../../shared/Button/CustomContainedButton';
import OutlinedButton from '../../shared/Button/customOutlinedButton';
import baseStyle from '../CSS/Base.module.css'

type PopUpProps = {
  open: boolean;
  handleClose: () => void;
  saveReopenChanges: () => void;
  saveReplaceChanges: () => void;
  message: string;
  popupTitle: string;
};

export default function BudgetPopUp(props: PopUpProps) {
  const { open, handleClose, saveReopenChanges, saveReplaceChanges, message, popupTitle } = props;
  const { t } = useTranslation();
  const translate = t as (key: string) => string;

  return (
    <Dialog
      open={open}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle sx={{
        backgroundColor: "#059ca9",
        color: 'white',
        display: 'flex',
        justifyContent: 'space-between',
        padding: '10px 10px'
      }}
      >
        {popupTitle}

        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            color: "white",
            padding: '0px'
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description" style={{ paddingTop: '20px', }}>
          <InputLabel sx={{ whiteSpace: 'normal', wordWrap: 'break-word', overflowWrap: 'break-word' }} >
            {message}
          </InputLabel>
        </DialogContentText>
      </DialogContent>
      <Divider />
      <DialogActions>
        <ContainedButton onClick={saveReopenChanges}>{translate('reopen')}</ContainedButton>
        <ContainedButton onClick={saveReplaceChanges}>{translate('replace')}</ContainedButton>
      </DialogActions>
    </Dialog>
  );
}
